<template>
    <v-container fluid :style="{'background-color':$store.getters.getColorPalette().backgroundColorCode}">
        <v-row>
            <v-col cols="12">
                <ShiftTable />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import ShiftTable from '@/components/lists/derived/ShiftTable'
export default {
    name:'ShiftsPage',
    components:{
        ShiftTable
    }
}
</script>